import { Axios } from "./index";
import * as Environment from "./../util/Environment";

export class OktaFactory{
    static _instance;

    static instance() {
        if (OktaFactory._instance == null) {
            OktaFactory._instance = new OktaFactory();
        }
        return OktaFactory._instance;
    }

   
    async getAppConfig(){
        const api_server = Environment.api_host("OKTA");
        const timestamp     =   (new Date()).getTime();
        const url   =   `${api_server}/getConfig?t=${timestamp}`;
        
        const authToken = window.localStorage.getItem("authToken");
        const authType = window.localStorage.getItem("authType");
        if(authToken == null || authType == null || authToken === undefined || authType == null){
            return [null,{'message':"User logged out.","status":-1}];
        }

        let response;
        try{
            response    =   await Axios.get(url, {
                headers: {'Authorization': authType+' '+authToken}
            });
        } catch(error){
            if(error.message === "Network Error"){
                //TODO Handle Network Error
                return [null,{'message':"Unable to connect to Server."}];
            } else if(error.response !== undefined){
                return [null,error.response.data];
            }
        }
        if(response.data === undefined){
            return [null,{"message":"Invalid Response from Server."}]
        }
        return [response.data,null];
    }

    async fetchUser(query, page, pageSize){
        const api_server = Environment.api_host("OKTA");
        const timestamp     =   (new Date()).getTime();
        const url   =   `${api_server}/users?t=${timestamp}&query=${query}&page=${page}&pageSize=${pageSize}`;
        
        const authToken = window.localStorage.getItem("authToken");
        const authType = window.localStorage.getItem("authType");
        if(authToken == null || authType == null || authToken === undefined || authType == null){
            return [null,{'message':"User logged out.","status":-1}];
        }

        let response;
        try{
            response    =   await Axios.get(url, {
                headers: {'Authorization': authType+' '+authToken}
            });
        } catch(error){
            if(error.message === "Network Error"){
                //TODO Handle Network Error
                return [null,{'message':"Unable to connect to Server."}];
            } else if(error.response !== undefined){
                return [null,error.response.data];
            }
        }
        if(response.data === undefined){
            return [null,{"message":"Invalid Response from Server."}]
        }
        return [response.data,null];
    }

}